export class SenhaT {
    public senha = '';
    public novaSenha = '';
}